import { render, staticRenderFns } from "./CreateJobSearchAssistanceFromList.vue?vue&type=template&id=60e3e3ef&"
import script from "./CreateJobSearchAssistanceFromList.vue?vue&type=script&lang=js&"
export * from "./CreateJobSearchAssistanceFromList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports